import { Box } from '@mui/material';
import { isPositiveSavings } from './utils';

export const HighlightBox = ({
  children,
  backgroundNegative,
  backgroundPositive,
}: {
  children?: string;
  backgroundNegative?: string;
  backgroundPositive?: string;
}) => (
  <Box
    sx={{
      padding: '4px 10px',
      borderRadius: '4px',
      background: (theme) =>
        isPositiveSavings(children)
          ? backgroundPositive || theme.palette.success.background
          : backgroundNegative || (theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[200]),
      lineHeight: '16px',
      width: 'fit-content',
    }}
  >
    {children}
  </Box>
);
